import {_t} from './../i18n/lang'

const MaterialTableLocale = {
    body: {
        emptyDataSourceMessage: _t('material-table-emptyDataSourceMessage'),
    },
    pagination: {
        labelDisplayedRows: _t('material-table-labelDisplayedRows'),
        labelRowsSelect: _t('material-table-labelRowsSelect'),
        labelRowsPerPage: _t('material-table-labelRowsPerPage'),
        firstAriaLabel: _t('material-table-firstAriaLabel'),
        firstTooltip: _t('material-table-firstTooltip'),
        previousAriaLabel: _t('material-table-previousAriaLabel'),
        previousTooltip: _t('material-table-previousTooltip'),
        nextAriaLabel: _t('material-table-nextAriaLabel'),
        nextTooltip: _t('material-table-nextTooltip'),
        lastAriaLabel: _t('material-table-lastAriaLabel'),
        lastTooltip: _t('material-table-lastTooltip'),
    },
    toolbar: {
        searchTooltip: _t('material-table-searchTooltip'),
        searchPlaceholder: _t('material-table-searchPlaceholder'),
    },
}

export const MaterialTableLocaleDelayed = () => {
    return  {
        body: {
            emptyDataSourceMessage: _t('material-table-emptyDataSourceMessage'),
        },
        pagination: {
            labelDisplayedRows: _t('material-table-labelDisplayedRows'),
            labelRowsSelect: _t('material-table-labelRowsSelect'),
            labelRowsPerPage: _t('material-table-labelRowsPerPage'),
            firstAriaLabel: _t('material-table-firstAriaLabel'),
            firstTooltip: _t('material-table-firstTooltip'),
            previousAriaLabel: _t('material-table-previousAriaLabel'),
            previousTooltip: _t('material-table-previousTooltip'),
            nextAriaLabel: _t('material-table-nextAriaLabel'),
            nextTooltip: _t('material-table-nextTooltip'),
            lastAriaLabel: _t('material-table-lastAriaLabel'),
            lastTooltip: _t('material-table-lastTooltip'),
        },
        toolbar: {
            searchTooltip: _t('material-table-searchTooltip'),
            searchPlaceholder: _t('material-table-searchPlaceholder'),
        },
    }
}
export default MaterialTableLocale;